import { render, staticRenderFns } from "./ProfilesControl.vue?vue&type=template&id=0e058c4b&"
import script from "./ProfilesControl.vue?vue&type=script&lang=js&"
export * from "./ProfilesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports